const FETCH_OFFICE_PROGRAMS_REQUEST = "FETCH_OFFICE_PROGRAMS_REQUEST";
const FETCH_OFFICE_PROGRAMS_SUCCESS = "FETCH_OFFICE_PROGRAMS_SUCCESS";
const FETCH_OFFICE_PROGRAMS_FAILURE = "FETCH_OFFICE_PROGRAMS_FAILURE";

export default {
  FETCH_OFFICE_PROGRAMS_REQUEST,
  FETCH_OFFICE_PROGRAMS_SUCCESS,
  FETCH_OFFICE_PROGRAMS_FAILURE,
};
